/**
 * Object contains all the module name
 */
export const Modules = {
	// dashboard: 'Dashboard',
	manageAdmin: 'Manage admin',
	broadcast: 'Broadcast',
	feedback: 'Feedback',
	help: 'help',
	callManagement: 'Call management',
	groups: 'Groups',
	manageAdminRoles: 'Manage admin roles',
	settings: 'Settings',
	team: 'Team',
	users: 'Users',
	appAccessControl: 'App access control',
	report: 'Reports',
	detailReport: 'ReplyFeedback'
};

/**
 * Object contains actions for the modules
 */
export const ModuleActions = {
	view: 'view',
	create: 'create',
	edit: 'edit',
	delete: 'delete',
	accessControl: 'access_control',
	add: 'add',
	import: 'Import',
	export: 'export'
};
